import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import { Grid } from '@/components/Grid';
import { theme } from '@/theme';

export const WatchesGrid = styled(Grid)`
  grid-template-columns: repeat(3, 1fr);

  ${theme.media.md.up} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const Background = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  left: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  height: 100%;
  top: 0;

  ${theme.media.md.up} {
    top: 35%;
    height: 64px;
  }
`;

const BaseWatchTypeSelection = styled(Flex)<{
  backgroundURL: string;
  isRefined: boolean;
}>`
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 65px;
  flex: 0 0 120px;
  height: 167px;
  position: relative;
  scroll-snap-align: start;
  width: 98px;
  border: 1px solid ${({ theme }) => theme.colors.mediumGrey};
  background-position-y: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(2)};

  ${({ isRefined }) =>
    isRefined &&
    css`
      border: 3px solid ${({ theme }) => theme.colors.primaryDark};
    `}
`;

export const WatchTypeSelection = styled(BaseWatchTypeSelection)`
  background-image: ${({ backgroundURL }) => `url(${backgroundURL})`};
  cursor: pointer;
`;

export const WatchName = styled.span`
  z-index: 1;
  line-height: 1rem;
  text-align: center;

  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.openSans};
    font-size: ${theme.fontSizes.p4};
    color: ${theme.colors.darkGrey};
  `}
`;
